import { SUBMOTIVE1_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSubmotive1List } from './hook';
import { Submotive1ListProps } from './props';

export const Submotive1List = ({ filters }: Submotive1ListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSubmotive1List(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SUBMOTIVE1_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
